import { Store, StoreConfig } from '@datorama/akita';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

export interface FeatureFlagState {
  [key: string]: boolean;
}

function createInitialState(): FeatureFlagState {
  return environment.featureFlags;
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'featureFlag',
  resettable: false
})
export class FeatureFlagStore extends Store<FeatureFlagState> {
  constructor() {
    super(createInitialState());
  }
}
